var telTypes = [
  { "name": "OfficeTel", "label": "تلفن دفتر", value: 0 },
  { "name": "Mobile", "label": "تلفن همراه", value: 1 },
  { "name": "HomeTel", "label": "تلفن منزل", value: 2 },
  { "name": "OtherTel", "label": "تلفن سایر", value: 3 },
  { "name": "OfficeFax", "label": "دورنگار دفتر", value: 4 },
  { "name": "HomeFax", "label": "دورنگار منزل", value: 5 },
  { "name": "OtherFax", "label": "دورنگار سایر", value: 6 },
];

export default telTypes;